export enum AutomationTagGeneratorBase {
    Activation = "Activation",
    Benchmark = "benchmark-tracker",
}

type AutomationTagPlaces = "home" | "report" | "root" | "builder" | (string & {});

// Generates value for data-automation tag to make more similar values
export const generateAutomationName = (
    place: AutomationTagPlaces,
    names: string[],
    base: AutomationTagGeneratorBase = AutomationTagGeneratorBase.Activation,
) => {
    let result = `${base}-${place}`;

    for (let index = 0; index < names.length; index++) {
        result = result.concat(`-${names[index]}`);
    }

    return result;
};
